import { render, staticRenderFns } from "./user_card.vue?vue&type=template&id=4dce452e&scoped=true&"
import script from "./user_card.vue?vue&type=script&lang=js&"
export * from "./user_card.vue?vue&type=script&lang=js&"
import style0 from "./user_card.vue?vue&type=style&index=0&id=4dce452e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dce452e",
  null
  
)

export default component.exports